import React, { useState } from 'react'
import styles from './ActionPanel.module.css'

const API_URL = process.env.REACT_APP_API_URL || ''


// Inline SVG icons
const SvgBag    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M8 12V8a4 4 0 014-4v0a4 4 0 014 4v4"/><path d="M3.694 12.668c.145-1.741.218-2.611.792-3.14C5.06 9 5.934 9 7.681 9h8.639c1.746 0 2.62 0 3.194.528.574.528.647 1.399.792 3.14l.514 6.166c.084 1.013.126 1.52-.17 1.843-.298.323-.806.323-1.824.323H5.174c-1.017 0-1.526 0-1.823-.323-.297-.323-.255-.83-.17-1.843l.513-6.166z"/></svg>
const SvgBook   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M4 4.5A2.5 2.5 0 016.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15z"/></svg>
const SvgNews   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M7 8h10M7 12h10M7 16h6"/></svg>
const SvgCal    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
const SvgPencil = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
const SvgGrad   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 10v6M2 10l10-5 10 5-10 5-10-5z"/><path d="M6 12v5c0 2 4 3 6 3s6-1 6-3v-5"/></svg>
const SvgLink   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>
const SvgLightning = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L4.09 12.54H11L10 22l8.91-10.54H13L14 2z"/></svg>
const SvgBolt = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M13 2L4.09 12.54H11L10 22l8.91-10.54H13L14 2z"/></svg>

const ACTION_CONFIG = {
    TAILOR_CV:   { icon: <SvgPencil />, label: 'Tailor CV',   color: '#7c3aed', bg: '#7c3aed18' },
    TAKE_COURSE: { icon: <SvgGrad />,   label: 'Take Course', color: '#0ea5e9', bg: '#0ea5e918' },
    READ_NEWS:   { icon: <SvgNews />,   label: 'Read News',   color: '#10b981', bg: '#10b98118' },
    APPLY:       { icon: <SvgBag />,    label: 'Apply',       color: '#f59e0b', bg: '#f59e0b18' },
}

const RELATED_ICON = { job: <SvgBag />, course: <SvgBook />, news: <SvgNews />, event: <SvgCal /> }

const getConfig = (actionType) =>
    ACTION_CONFIG[actionType] || { icon: <SvgLightning />, label: actionType || 'Action', color: '#432C5B', bg: '#432C5B18' }

/**
 * ActionPanel renders one row per action GROUP (action_type).
 * Each group can have multiple related content items (courses/news/events).
 * Prop: actions = [{action_type, description, status, primary_content_id, relatedItems:[]}]
 */
const ActionPanel = ({ actions }) => {
    // saveState: { "primaryContentId:action_type": 'idle' | 'saving' | 'saved' | 'error' }
    // AND individual item saves: { "action_id": 'idle' | 'saving' | 'saved' }
    const [saveState, setSaveState] = useState(() => {
        const init = {}
        actions.forEach(a => {
            const k = `${a.primary_content_id}:${a.action_type}`
            init[k] = a.status === 'accepted' ? 'saved' : 'idle'
            if (a.relatedItems) {
                a.relatedItems.forEach(item => {
                    init[item.action_id] = item.status === 'accepted' ? 'saved' : 'idle'
                })
            }
        })
        return init
    })

    const handleAddGroup = async (action) => {
        const k = `${action.primary_content_id}:${action.action_type}`
        if (saveState[k] === 'saving' || saveState[k] === 'saved') return
        setSaveState(prev => ({ ...prev, [k]: 'saving' }))
        try {
            const res = await fetch(`${API_URL}/feed/save-action`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    primary_content_id: action.primary_content_id,
                    action_type:        action.action_type,
                }),
            })
            if (res.ok) {
                setSaveState(prev => {
                    const next = { ...prev, [k]: 'saved' }
                    // Mark all related items as saved too
                    if (action.relatedItems) {
                        action.relatedItems.forEach(item => { next[item.action_id] = 'saved' })
                    }
                    return next
                })
            } else {
                setSaveState(prev => ({ ...prev, [k]: 'error' }))
                setTimeout(() => setSaveState(prev => ({ ...prev, [k]: 'idle' })), 2500)
            }
        } catch {
            setSaveState(prev => ({ ...prev, [k]: 'error' }))
            setTimeout(() => setSaveState(prev => ({ ...prev, [k]: 'idle' })), 2500)
        }
    }

    const handleAddItem = async (e, item) => {
        e.preventDefault() // prevent navigating to URL
        e.stopPropagation()
        const k = item.action_id
        if (saveState[k] === 'saving' || saveState[k] === 'saved') return
        setSaveState(prev => ({ ...prev, [k]: 'saving' }))
        try {
            const res = await fetch(`${API_URL}/feed/save-action-by-id`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action_id: item.action_id }),
            })
            if (res.ok) {
                setSaveState(prev => ({ ...prev, [k]: 'saved' }))
            } else {
                setSaveState(prev => ({ ...prev, [k]: 'error' }))
                setTimeout(() => setSaveState(prev => ({ ...prev, [k]: 'idle' })), 2500)
            }
        } catch {
            setSaveState(prev => ({ ...prev, [k]: 'error' }))
            setTimeout(() => setSaveState(prev => ({ ...prev, [k]: 'idle' })), 2500)
        }
    }

    if (!actions || actions.length === 0) return null

    return (
        <div className={styles.panel}>
            <h4 className={styles.panelHeading}><SvgBolt /> ACTIONS YOU CAN TAKE</h4>
            <div className={styles.groupList}>
                {actions.map((action, idx) => {
                    const config  = getConfig(action.action_type)
                    const k       = `${action.primary_content_id}:${action.action_type}`
                    const groupState = saveState[k] || 'idle'
                    const isGroupSaved  = groupState === 'saved'
                    const isGroupSaving = groupState === 'saving'
                    const isGroupError  = groupState === 'error'
                    
                    // Check if *all* related items are saved individually
                    const allItemsSaved = action.relatedItems && action.relatedItems.length > 0 && 
                        action.relatedItems.every(item => saveState[item.action_id] === 'saved')

                    const isEffectivelySaved = isGroupSaved || allItemsSaved

                    return (
                        <div key={`${action.action_type}-${idx}`} className={`${styles.group} ${isEffectivelySaved ? styles.groupSaved : ''}`}>
                            {/* Top row: type pill + description + button */}
                            <div className={styles.groupTop}>
                                <div className={styles.groupLeft}>
                                    <span
                                        className={styles.typePill}
                                        style={{ background: config.bg, color: config.color }}
                                    >
                                        {config.icon} {config.label}
                                    </span>
                                    <p className={styles.desc}>{action.description}</p>
                                </div>
                                <button
                                    className={`${styles.addBtn} ${isEffectivelySaved ? styles.addBtnSaved : ''} ${isGroupError ? styles.addBtnError : ''}`}
                                    onClick={() => handleAddGroup(action)}
                                    disabled={isEffectivelySaved || isGroupSaving}
                                    title={isEffectivelySaved ? 'Already in your actions' : (action.relatedItems?.length > 1 ? 'Add All' : 'Add to My Actions')}
                                >
                                    {isGroupSaving ? (
                                        <span className={styles.spinner} />
                                    ) : isEffectivelySaved ? (
                                        '✓ Added'
                                    ) : isGroupError ? (
                                        '! Retry'
                                    ) : (action.relatedItems?.length > 1 ? '+ Add All' : '+ Add Action')}
                                </button>
                            </div>

                            {/* Related content chips */}
                            {action.relatedItems && action.relatedItems.length > 0 && (
                                <div className={styles.relatedList}>
                                    {action.relatedItems.map((item, i) => {
                                        const itemState = saveState[item.action_id] || 'idle'
                                        const isItemSaved = itemState === 'saved' || isGroupSaved
                                        const isItemSaving = itemState === 'saving'
                                        
                                        return (
                                        <div key={i} className={styles.relatedChipWrapper}>
                                            <a
                                                href={item.url || '#'}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.relatedChip}
                                                onClick={e => !item.url && e.preventDefault()}
                                            >
                                                <span className={styles.relatedIcon}>{RELATED_ICON[item.type] || <SvgLink />}</span>
                                                <span className={styles.relatedTitle}>{item.title}</span>
                                                {item.subtitle && (
                                                    <span className={styles.relatedSub}> · {item.subtitle}</span>
                                                )}
                                                {item.url && <span className={styles.relatedArrow}>↗</span>}
                                            </a>
                                            <button
                                                className={`${styles.addItemBtn} ${isItemSaved ? styles.addItemBtnSaved : ''}`}
                                                onClick={(e) => handleAddItem(e, item)}
                                                disabled={isItemSaved || isItemSaving}
                                                title={isItemSaved ? 'Added' : 'Add this item'}
                                            >
                                                {isItemSaving ? (
                                                    <span className={styles.spinnerSmall} />
                                                ) : isItemSaved ? (
                                                    '✓'
                                                ) : (
                                                    '+'
                                                )}
                                            </button>
                                        </div>
                                    )})}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ActionPanel
